export default "__VITE_ASSET__BbLkVud7__"